import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15.993 4.715l.018-.018-.707-.707-.018.018c-1.509-1.332-3.394-2.007-5.285-2.007-2.047 0-4.095.781-5.657 2.343-3.005 3.005-3.111 7.8-.336 10.942l-.018.018.353.353.001.001.001.001.353.353.018-.018c1.509 1.333 3.395 2.007 5.285 2.007 2.047 0 4.095-.781 5.657-2.343 3.005-3.005 3.111-7.8.336-10.942zM3 10c0-1.87.728-3.628 2.05-4.95S8.13 3 10 3c1.702 0 3.307.609 4.579 1.714l-9.865 9.865C3.609 13.307 3 11.702 3 10zm11.95 4.95C13.628 16.272 11.87 17 10 17c-1.702 0-3.307-.609-4.579-1.714l9.865-9.865C16.391 6.693 17 8.298 17 10c0 1.87-.728 3.628-2.05 4.95z',
  ],
  height: 20,
  width: 20,
});
